import React from 'react';
import { FaIdCard } from 'react-icons/fa';
import DepartamentoPedidosPage from './DepartamentoPedidosPage';

const AtualizacaoCadastralPage = () => (
  <DepartamentoPedidosPage
    departamentoId="atualizacao-cadastral"
    titulo="Atualização Cadastral"
    Icon={FaIdCard}
  />
);

export default AtualizacaoCadastralPage;
